/* ============================================================
   Trampoline Warehouse — 2026 design refresh interactions
   Scroll reveal · count-up stats · delivery countdown ·
   sticky buy bar · size helper · compare tray
   ============================================================ */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* On shared theme previews, Shopify injects a bottom preview bar in the
     browser top layer which would cover our bottom-fixed elements. */
  function liftAbovePreviewBar(el) {
    if (!el) return;
    var bar = document.getElementById('PBarNextFrameWrapper')
      || document.getElementById('preview-bar-iframe')
      || document.querySelector('iframe[src*="preview-bar"]');
    if (bar) el.style.bottom = '4.8rem';
  }

  /* ---------- scroll reveal ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.tw-reveal:not(.tw-in)');
    if (!els.length) return;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('tw-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tw-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
    /* safety net: never leave content stuck hidden */
    setTimeout(function () {
      els.forEach(function (el) { el.classList.add('tw-in'); });
    }, 2600);
  }

  /* ---------- count-up numbers ---------- */
  function initCounters(root) {
    var nums = (root || document).querySelectorAll('[data-tw-count]:not([data-tw-counted])');
    if (!nums.length) return;
    function finish(el) {
      var target = parseFloat(el.getAttribute('data-tw-count'));
      var dec = parseInt(el.getAttribute('data-tw-dec') || '0', 10);
      el.textContent = (el.getAttribute('data-tw-pre') || '')
        + target.toLocaleString('en-GB', { minimumFractionDigits: dec, maximumFractionDigits: dec })
        + (el.getAttribute('data-tw-suf') || '');
    }
    if (reducedMotion || !('IntersectionObserver' in window)) {
      nums.forEach(function (el) { el.setAttribute('data-tw-counted', ''); finish(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.setAttribute('data-tw-counted', '');
        var target = parseFloat(el.getAttribute('data-tw-count'));
        var dec = parseInt(el.getAttribute('data-tw-dec') || '0', 10);
        var pre = el.getAttribute('data-tw-pre') || '';
        var suf = el.getAttribute('data-tw-suf') || '';
        var start = performance.now();
        var dur = 1400;
        function step(now) {
          var p = Math.min((now - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = pre
            + (target * eased).toLocaleString('en-GB', { minimumFractionDigits: dec, maximumFractionDigits: dec })
            + suf;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        io.unobserve(el);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (el) { io.observe(el); });
  }

  /* ---------- delivery countdown to daily dispatch cutoff ----------
     Mon–Thu before cutoff  → "Order in the next Xh Ym for Next Day Delivery"
     Fri before cutoff      → "Order in the next Xh Ym for Monday Delivery"
     Mon/Tue/Wed after      → Wednesday / Thursday / Friday Delivery
     Thu after              → Monday Delivery
     Fri after + weekend    → Tuesday Delivery */
  var countdownTimer = null;
  var TW_AFTER_CUTOFF_DAY = {
    0: 'Tuesday',
    1: 'Wednesday',
    2: 'Thursday',
    3: 'Friday',
    4: 'Monday',
    5: 'Tuesday',
    6: 'Tuesday'
  };
  function twLondonNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      return {
        day: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(o.weekday),
        secs: (parseInt(o.hour, 10) % 24) * 3600 + parseInt(o.minute, 10) * 60 + parseInt(o.second, 10)
      };
    } catch (e) {
      var d = new Date();
      return { day: d.getDay(), secs: d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds() };
    }
  }
  function tickCountdowns() {
    var els = document.querySelectorAll('[data-tw-cutoff]');
    if (!els.length) return;
    var now = twLondonNow();
    els.forEach(function (el) {
      var cutoff = parseInt(el.getAttribute('data-tw-cutoff') || '11', 10);
      var left = cutoff * 3600 - now.secs;
      var isWeekday = now.day >= 1 && now.day <= 5;
      var html;
      if (isWeekday && left > 0) {
        var label = now.day === 5 ? 'Monday' : 'Next Day';
        var h = Math.floor(left / 3600);
        var m = Math.floor((left % 3600) / 60);
        var s = left % 60;
        var time = h > 0 ? h + 'h ' + m + 'm' : m > 0 ? m + 'm' : s + 's';
        html = '· Order in the next <b class="tw-stock__count">' + time + '</b> for ' + label + ' Delivery';
      } else {
        html = '· Order now for <b class="tw-stock__count">' + TW_AFTER_CUTOFF_DAY[now.day] + '</b> Delivery';
      }
      if (el.getAttribute('data-tw-msg') !== html) {
        el.setAttribute('data-tw-msg', html);
        el.innerHTML = html;
      }
    });
  }
  function initCountdowns() {
    if (!document.querySelector('[data-tw-cutoff]')) return;
    tickCountdowns();
    if (!countdownTimer) countdownTimer = setInterval(tickCountdowns, 1000);
  }

  /* ---------- sticky mobile buy bar ---------- */
  function initBuybar() {
    var bar = document.querySelector('[data-tw-buybar]');
    if (!bar || bar.hasAttribute('data-tw-ready')) return;
    bar.setAttribute('data-tw-ready', '');
    var anchor = document.querySelector('.product-form__buttons') || document.querySelector('.product__info-container');
    if (!anchor) return;
    function onScroll() {
      var rect = anchor.getBoundingClientRect();
      var show = rect.bottom < 60;
      bar.classList.toggle('tw-show', show);
      if (show) liftAbovePreviewBar(bar);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var trigger = bar.querySelector('[data-tw-buybar-add]');
    if (trigger) {
      trigger.addEventListener('click', function () {
        var submit = document.querySelector('.product-form__submit');
        if (submit && !submit.disabled) {
          submit.click();
        } else {
          var info = document.querySelector('.product__info-container');
          if (info) info.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' });
        }
      });
    }
  }

  /* ---------- size helper quiz ---------- */
  function initHelper(root) {
    (root || document).querySelectorAll('[data-tw-helper]').forEach(function (helper) {
      if (helper.hasAttribute('data-tw-ready')) return;
      helper.setAttribute('data-tw-ready', '');
      var dataEl = helper.querySelector('[data-tw-helper-data]');
      var recs = {};
      if (dataEl) {
        try { recs = JSON.parse(dataEl.textContent); } catch (e) { recs = {}; }
      }
      var selection = {};
      helper.querySelectorAll('[data-tw-opt-group]').forEach(function (row) {
        row.addEventListener('click', function (event) {
          var button = event.target.closest('[data-tw-opt]');
          if (!button) return;
          row.querySelectorAll('[data-tw-opt]').forEach(function (opt) {
            opt.setAttribute('aria-pressed', 'false');
          });
          button.setAttribute('aria-pressed', 'true');
          selection[row.getAttribute('data-tw-opt-group')] = button.getAttribute('data-tw-opt');
          if (selection.age && selection.space) {
            var rec = recs[selection.age + '-' + selection.space];
            if (!rec) return;
            var result = helper.querySelector('[data-tw-helper-result]');
            var sizeEl = helper.querySelector('[data-tw-helper-size]');
            var whyEl = helper.querySelector('[data-tw-helper-why]');
            var linkEl = helper.querySelector('[data-tw-helper-link]');
            if (sizeEl) sizeEl.textContent = rec.size || '';
            if (whyEl) whyEl.textContent = rec.why || '';
            if (linkEl && rec.url) linkEl.setAttribute('href', rec.url);
            if (result) result.classList.add('tw-show');
          }
        });
      });
    });
  }

  /* ---------- compare tray ---------- */
  var compare = [];
  function compareRefresh() {
    var tray = document.querySelector('[data-tw-compare-tray]');
    if (!tray) return;
    var slots = tray.querySelector('[data-tw-compare-slots]');
    var button = tray.querySelector('[data-tw-compare-open]');
    var emptyText = tray.getAttribute('data-tw-compare-empty') || '';
    if (!compare.length) {
      slots.innerHTML = '<span class="tw-compare-tray__empty">' + emptyText + '</span>';
      tray.classList.remove('tw-show');
      button.disabled = true;
      button.textContent = button.getAttribute('data-tw-compare-label') + ' (0)';
      return;
    }
    tray.classList.add('tw-show');
    liftAbovePreviewBar(tray);
    button.disabled = false;
    button.textContent = button.getAttribute('data-tw-compare-label') + ' (' + compare.length + ')';
    slots.textContent = '';
    compare.forEach(function (item) {
      var slot = document.createElement('span');
      slot.className = 'tw-compare-tray__slot';
      slot.appendChild(document.createTextNode(item.title));
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.setAttribute('aria-label', 'Remove ' + item.title);
      remove.textContent = '✕';
      remove.addEventListener('click', function () {
        compareToggle(item, null);
        var box = document.querySelector('[data-tw-compare][data-tw-compare-id="' + item.id + '"]');
        if (box) box.checked = false;
      });
      slot.appendChild(remove);
      slots.appendChild(slot);
    });
  }
  function compareToggle(item, checkbox) {
    var index = compare.findIndex(function (entry) { return entry.id === item.id; });
    if (index > -1) {
      compare.splice(index, 1);
    } else {
      if (compare.length >= 3) {
        if (checkbox) checkbox.checked = false;
        return;
      }
      compare.push(item);
    }
    compareRefresh();
  }
  /* measurement metafields (e.g. max user weight) can arrive as {value, unit}
     objects from cached pages — flatten to "150 kg" instead of [object Object] */
  function compareCellText(value) {
    if (value && typeof value === 'object') {
      var text = '';
      if (value.value != null) text += value.value;
      if (value.unit) text += (text ? ' ' : '') + value.unit;
      return text || '—';
    }
    return value || '—';
  }
  function compareRow(label, cells) {
    var tr = document.createElement('tr');
    var labelCell = document.createElement('td');
    labelCell.className = 'tw-compare-table__label';
    labelCell.textContent = label;
    tr.appendChild(labelCell);
    cells.forEach(function (cell) { tr.appendChild(cell); });
    return tr;
  }
  function compareOpenModal() {
    var modal = document.querySelector('[data-tw-compare-modal]');
    if (!modal || !compare.length) return;
    var table = modal.querySelector('[data-tw-compare-table]');
    table.textContent = '';
    var head = document.createElement('tr');
    head.appendChild(document.createElement('td'));
    compare.forEach(function (item) {
      var th = document.createElement('th');
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title;
        img.loading = 'lazy';
        img.width = 90;
        img.height = 90;
        th.appendChild(img);
        th.appendChild(document.createElement('br'));
      }
      var link = document.createElement('a');
      link.href = item.url;
      link.textContent = item.title;
      th.appendChild(link);
      head.appendChild(th);
    });
    table.appendChild(head);
    table.appendChild(compareRow(modal.getAttribute('data-tw-label-price') || 'Price', compare.map(function (item) {
      var td = document.createElement('td');
      var price = document.createElement('span');
      price.className = 'tw-compare-table__price';
      price.textContent = item.price;
      td.appendChild(price);
      if (item.compare_at) {
        td.appendChild(document.createElement('br'));
        var was = document.createElement('s');
        was.textContent = item.compare_at;
        td.appendChild(was);
      }
      return td;
    })));
    ['size', 'springs', 'frame', 'weight'].forEach(function (key) {
      var hasValue = compare.some(function (item) { return item[key]; });
      if (!hasValue) return;
      table.appendChild(compareRow(modal.getAttribute('data-tw-label-' + key) || key, compare.map(function (item) {
        var td = document.createElement('td');
        td.textContent = compareCellText(item[key]);
        return td;
      })));
    });
    modal.classList.add('tw-show');
    document.body.style.overflow = 'hidden';
  }
  function compareCloseModal() {
    var modal = document.querySelector('[data-tw-compare-modal]');
    if (!modal) return;
    modal.classList.remove('tw-show');
    document.body.style.overflow = '';
  }
  var compareDelegated = false;
  function initCompare(root) {
    /* delegated: survives facet-filter AJAX re-renders of the product grid */
    if (!compareDelegated) {
      compareDelegated = true;
      document.addEventListener('change', function (event) {
        var checkbox = event.target.closest ? event.target.closest('[data-tw-compare]') : null;
        if (!checkbox) return;
        var item;
        try { item = JSON.parse(checkbox.getAttribute('data-tw-compare-item')); } catch (e) { return; }
        item.id = checkbox.getAttribute('data-tw-compare-id');
        compareToggle(item, checkbox);
      });
      /* restore ticked state after facet filtering re-renders the grid */
      var gridContainer = document.getElementById('ProductGridContainer');
      if (gridContainer && 'MutationObserver' in window) {
        new MutationObserver(function () {
          compare.forEach(function (item) {
            var box = document.querySelector('[data-tw-compare][data-tw-compare-id="' + item.id + '"]');
            if (box) box.checked = true;
          });
        }).observe(gridContainer, { childList: true, subtree: true });
      }
    }
    var tray = document.querySelector('[data-tw-compare-tray]');
    if (tray && !tray.hasAttribute('data-tw-ready')) {
      tray.setAttribute('data-tw-ready', '');
      tray.querySelector('[data-tw-compare-open]').addEventListener('click', compareOpenModal);
    }
    var modal = document.querySelector('[data-tw-compare-modal]');
    if (modal && !modal.hasAttribute('data-tw-ready')) {
      modal.setAttribute('data-tw-ready', '');
      modal.addEventListener('click', function (event) {
        if (event.target === modal) compareCloseModal();
      });
      modal.querySelector('[data-tw-compare-close]').addEventListener('click', compareCloseModal);
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') compareCloseModal();
      });
    }
  }

  /* ---------- boot ---------- */
  function initAll(root) {
    initReveal(root);
    initCounters(root);
    initCountdowns();
    initBuybar();
    initHelper(root);
    initCompare(root);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
